import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const GatepassPage = () => {
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [studentDetails, setStudentDetails] = useState(null);
  const [guardians, setGuardians] = useState([]);
  const [parentId, setParentId] = useState("");
  const [parentDetails, setParentDetails] = useState(null);
  const [guardianDetails, setGuardianDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedChild, setSelectedChild] = useState(null); 

  const navigate = useNavigate();

  // Fetch classes on mount
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`);
        setClasses(response.data);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClasses();
  }, []);

  // Fetch sections based on selected class
  useEffect(() => {
    if (selectedClass) {
      const fetchSections = async () => {
        try {
          const response = await axios.get(
            ` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName`
          );
          setSections(response.data);
        } catch (error) {
          console.error("Error fetching sections:", error);
        }
      };
      fetchSections();
    }
  }, [selectedClass]);

  // Fetch students based on selected class and section
  useEffect(() => {
    if (selectedClass && selectedSection) {
      const fetchStudents = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`);
          const filteredStudents = response.data.filter(
            (student) =>
              student.class === selectedClass &&
              student.section === selectedSection &&
              student.status === "active"
          );
          setStudents(filteredStudents);
        } catch (error) {
          console.error("Error fetching students:", error);
        }
      };
      fetchStudents();
    }
  }, [selectedClass, selectedSection]);

  // Fetch guardian details for selected student
  useEffect(() => {
    if (selectedStudent) {
      const fetchGuardians = async () => {
        try {
          const response = await axios.get(
            ` ${process.env.REACT_APP_API_BASE_URL}/api/guardians/getGuardiansByStudentId/${selectedStudent}`
          );
          setGuardians(response.data.guardians || []);
        } catch (error) {
          console.error("Error fetching guardians:", error);
        }
      };
      const fetchStudentDetails = async () => {
        try {
          const response = await axios.get(
            ` ${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${selectedStudent}`
          );
          setStudentDetails(response.data);
        } catch (error) {
          console.error("Error fetching student deatails:", error);
        }
      };
      fetchStudentDetails();
      fetchGuardians();
    }
  }, [selectedStudent]);

  // Fetch parent details by ID
  const handleParentSearch = async () => {
    if (!parentId) return;
    setLoading(true);
    try {
      const response = await axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/parents/getParent/${parentId}`);
      setParentDetails(response.data);
      const response2 = await axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/guardians/getGuardiansByparentID/${parentId}`);
      setGuardianDetails(response2.data.guardians);
    } catch (error) {
      console.error("Error fetching parent details:", error);
      setParentDetails(null);
    } finally {
      setLoading(false);
    }
  };

  const handleChildSelection = (child) => {
    setSelectedChild(child);
  };

  return (
    <div className="max-w-screen mx-auto p-6 bg-white shadow rounded-lg">
      <h1 className="text-3xl font-bold text-center mb-6">Gatepass Management</h1>

      {/* Search by Student */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-4">Search by Student</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            className="p-2 border rounded"
          >
            <option value="">Select Class</option>
            {classes.map((classItem) => (
              <option key={classItem.id} value={classItem.className}>
                {classItem.className}
              </option>
            ))}
          </select>
          <select
            value={selectedSection}
            onChange={(e) => setSelectedSection(e.target.value)}
            className="p-2 border rounded"
            disabled={!selectedClass}
          >
            <option value="">Select Section</option>
            {sections.map((section) => (
              <option key={section.id} value={section.sectionName}>
                {section.sectionName}
              </option>
            ))}
          </select>
          <select
            value={selectedStudent}
            onChange={(e) => setSelectedStudent(e.target.value)}
            className="p-2 border rounded"
            disabled={!selectedSection}
          >
            <option value="">Select Student</option>
            {students.map((student) => (
              <option key={student._id} value={student._id}>
                {student.firstName} {student.lastName}
              </option>
            ))}
          </select>
        </div>
        {guardians.length > 0 && (
            <div>
            <h3 className="text-lg font-bold mt-6">Guardian Details</h3>
            <table className="table-auto w-full border-collapse border border-gray-300 text-center">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border px-4 py-2">#</th>
                  <th className="border px-4 py-2">Name</th>
                  <th className="border px-4 py-2">Phone</th>
                  <th className="border px-4 py-2">Relation</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    name: studentDetails.fatherName,
                    phone: studentDetails.phoneNo,
                    relation: "Father",
                  },
                  {
                    name: studentDetails.motherName,
                    phone: studentDetails.phoneNo2,
                    relation: "Mother",
                  },
                  ...guardians.map((guardian) => ({
                    name: guardian.name,
                    phone: guardian.phone,
                    relation: guardian.relation,
                  })),
                ].map((person, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        onChange={() => handleChildSelection(person)}
                        checked={selectedChild?.name === person.name}
                      />
                    </td>
                    <td className="border px-4 py-2">{person.name}</td>
                    <td className="border px-4 py-2">{person.phone}</td>
                    <td className="border px-4 py-2">{person.relation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
        )}
      </div>

      {/* Search by Parent ID */}
      <div>
        <h2 className="text-xl font-semibold mb-4">Search by Parent ID</h2>
        <div className="flex gap-4 mb-4">
          <input
            type="text"
            placeholder="Enter Parent ID"
            value={parentId}
            onChange={(e) => setParentId(e.target.value)}
            className="p-2 border rounded flex-1"
          />
          <button
            onClick={handleParentSearch}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            Search
          </button>
        </div>
        {loading && <p>Loading...</p>}
        {parentDetails && (
          <div>
            <h3 className="text-lg font-bold mt-6">Guardian Details</h3>
            <table className="table-auto w-full border-collapse border border-gray-300 text-center">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border px-4 py-2">#</th>
                  <th className="border px-4 py-2">Name</th>
                  <th className="border px-4 py-2">Phone</th>
                  <th className="border px-4 py-2">Relation</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    name: parentDetails.fatherName,
                    phone: parentDetails.phoneNo,
                    relation: "Father",
                  },
                  {
                    name: parentDetails.motherName,
                    phone: parentDetails.phoneNo2,
                    relation: "Mother",
                  },
                  ...guardianDetails.map((guardian) => ({
                    name: guardian.name,
                    phone: guardian.phone,
                    relation: guardian.relation,
                  })),
                ].map((person, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        onChange={() => handleChildSelection(person)}
                        checked={selectedChild?.name === person.name}
                      />
                    </td>
                    <td className="border px-4 py-2">{person.name}</td>
                    <td className="border px-4 py-2">{person.phone}</td>
                    <td className="border px-4 py-2">{person.relation}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {selectedChild && (
              <div className="mt-6">
                <h3 className="text-lg font-bold">Selected Person Details</h3>
                <p>Name: {selectedChild.name}</p>
                <p>Phone: {selectedChild.phone}</p>
                <p>Relation: {selectedChild.relation}</p>
              </div>
            )}
            <h3 className="text-lg font-bold text-gray-700 mt-6 mb-2">Children:</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {parentDetails.children.map((child) => (
                <div
                  key={child._id}
                  className="flex items-center gap-4 bg-gray-100 p-4 rounded-lg shadow-sm"
                >
                  <input type="checkbox" id={`child-${child.firstName} {child.lastName}`} />
                  <label htmlFor={`child-${child.firstName} {child.lastName}`} className="flex-1">
                    {child.firstName} {child.lastName} (Class: {child.class} [{child.section}])
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GatepassPage;
